const FeedHeader = ({
  headerText,
  subtitleText,
}: {
  headerText: string;
  subtitleText?: string;
}) => {
  return (
    <div className="FeedHeader flex mb-2 mt-2">
      <div className="flex flex-col">
        <div className="text-lg font-semibold">{headerText}</div>
        {subtitleText && (
          <div className="mt-1 text-gray-400">{subtitleText}</div>
        )}
      </div>
    </div>
  );
};

export default FeedHeader;
